import { getBaseURL } from '@/utils/util'
const baseURL = getBaseURL('api')
const filebaseURL = getBaseURL('api', true)

export const getCouponData = data => window.axios({
  url: baseURL + 'scoreDetail/scoreDetail',
  data
})

export const downloadCouponData = data => window.axios({
  url: filebaseURL + 'scoreDetail/downloadScoreDetail',
  data
})

export const getWalletExpenditureDate = data => window.axios({
  url: baseURL + 'walletAccount/costPage',
  data
})

export const getWalletRechargeDate = data => window.axios({
  url: baseURL + 'walletAccount/rechargePage',
  data
})

export const getMalayExpenditureDate = data => window.axios({
  url: baseURL + 'visaFeeDetail/listMalayFeeDetail',
  data
})

export const getAccountRechargeDate = data => window.axios({
  url: baseURL + 'visaFeeDetail/listFeeDetailOfRecharge',
  data
})

export const getUSAExpenditureDate = data => window.axios({
  url: baseURL + 'visaFeeDetail/usInterviewFeeDetailList',
  data
})

export const downloadAccountRechargeData = data => window.axios({
  url: baseURL + 'visaFeeDetail/downloadFeeDetailOfRecharge',
  data
})

export const downloadMalayExpenditureData = data => window.axios({
  url: baseURL + 'visaFeeDetail/downloadMalayFeeDetail',
  data
})

export const downloadUSAntExpenditureData = data => window.axios({
  url: baseURL + 'visaFeeDetail/usInterviewFeeDetailListDownload',
  data
})

export const downloadWalletRechargeData = data => window.axios({
  url: filebaseURL + 'walletAccount/recharge/export',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  responseType: 'blob',
}).then(result => {
  if (result) {
    if (result.type === 'application/json') {
      const reader = new FileReader()
      reader.onload = e => {
        const { code, msg } = JSON.parse(e.target.result)
        if (code === 20002) {
          window.vbus.$message.error(msg)
        }
      }
      reader.readAsText(result)
    } else {
      return result
    }
  }
})

export const downloadWalletExpenditureData = data => window.axios({
  url: filebaseURL + 'walletAccount/cost/export',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  responseType: 'blob',
}).then(result => {
  if (result) {
    if (result.type === 'application/json') {
      const reader = new FileReader()
      reader.onload = e => {
        const { code, msg } = JSON.parse(e.target.result)
        if (code === 20002) {
          window.vbus.$message.error(msg)
        }
      }
      reader.readAsText(result)
    } else {
      return result
    }
  }
})

export const getTicketList = () => window.axios({
  method: 'get',
  url: baseURL + 'score/scorePayConfigList'
})

export const confirmToRecharge = data => window.axios({
  url: baseURL + 'score/pagePay',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const visaFeeRecharge = data => window.axios({
  url: baseURL + 'visaFeeDetail/recharge',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const finishVisaFeeRecharge = data => window.axios({
  url: baseURL + 'visaFeeDetail/confirmRecharge',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const getVisaFeeConfig = () => window.axios({
  method: 'get',
  url: baseURL + 'visaFinance/getConfigInfo'
})

export const walletRecharge = data => window.axios({
  url: baseURL + 'walletAccount/pagePay',
  data
})

export const mallRecharge = data => window.axios({
  url: baseURL + 'mall/account/zmPay',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const getVisaBalance = () => window.axios({
  method: 'get',
  url: baseURL + 'visaOrderApply/getBalance',
})

export const getWalletBalance = () => window.axios({
  method: 'get',
  url: baseURL + 'walletAccount/getBalance',
})

export const getMallBalance = () => window.axios({
  method: 'get',
  url: baseURL + 'mall/account/getBalance'
})

export const getMerchantBalance = () => window.axios({
  method: 'get',
  url: baseURL + 'vcc/merchant/getMerchantBalance?v=' + Date.now()
})

export const getInsuranceCompanyBalance = () => window.axios({
  method: 'get',
  url: baseURL + 'insurance/company/balance/getBalance?v=' + Date.now()
})

export const getAuthUrl = () => window.axios({
  method: 'get',
  url: baseURL + 'vcc/merchant/authUrl?v=' + Date.now()
})

export const getMallFinancialData = data => window.axios({
  url: baseURL + 'mall/account/recordPageList',
  data
})

export const checkZMRecharge = data => window.axios({
  url: baseURL + 'zmpay/filterOrder',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const recordExport = data => window.axios({
  url: baseURL + 'mall/account/recordExport',
  data
})
